import { FieldProps } from 'formik';
import { useCallback } from 'react';
import {
  FormPageAuthInputData,
  FormPageAuthProperty,
  FormPageAuthInputItem,
  valueOf,
} from 'shared';

type UsePropertyContainerHandlerPayload = {
  fieldProps: FieldProps<FormPageAuthInputItem, FormPageAuthInputData>;
  propertyId: FormPageAuthProperty['propertyId'];
};

type UpdateFieldValue<T extends FormPageAuthInputItem = FormPageAuthInputItem> =
  (key: keyof T, value: valueOf<T>) => void;

type UsePropertyContainerHandlerReturnType<
  T extends FormPageAuthInputItem = FormPageAuthInputItem
> = {
  updateFieldValue: UpdateFieldValue<T>;
};

export const useFieldPropsHandler = <
  T extends FormPageAuthInputItem = FormPageAuthInputItem
>({
  fieldProps,
  propertyId,
}: UsePropertyContainerHandlerPayload): UsePropertyContainerHandlerReturnType<T> => {
  const { setValues } = fieldProps.form;
  const updateFieldValue: UpdateFieldValue<T> = useCallback(
    (key, value) => {
      setValues((values) => ({
        ...values,
        [propertyId]: {
          ...values[propertyId],
          [key]: value,
        },
      }));
    },
    [setValues, propertyId]
  );

  return {
    updateFieldValue,
  };
};
